import React from 'react';

import validator from 'validator';

export const requiredValidation = value => !value.toString().trim().length
  && <div className="clr_primary h6 mt_1">не может быть пустым</div>;

export const emailValidation = value => !validator.isEmail(value)
  && <div className="clr_primary h6 mt_1">email введён неверно</div>;
